require('./image-display/image-display.scss');
var BaseViews = require('../base');
var View = BaseViews.LayoutView.extend({
  template: require('./image-display/image-display.html'),
  className: 'fmcy-image-display',
  imageLoaded: false,
  afterImageLoaded: false,
  ui: {
    image: '.fmcy-image',
    imageLarge: '.fmcy-large-image'
  },
  regions: {
    loaderRegion: '.fmcy-loader-region'
  },
  initialize: function (options) {
    var self = this;
    self.options = _.defaults(
      options || {}, {
        noImageAvailableIcon: require('./image-display/no-image-available.png'),
        displayNoImageAvailableIcon: true,
        imageURL: null,
        afterLoadImageURL: null,
        displayImagePreloadingEffects: true,
        imagePreloadTimeout: 60000, // 1 minute in msx
      }
    );

    if (self.options.displayImagePreloadingEffects || self.afterLoadImageURL !== null) {
      var createjs = require('preload-js');
      createjs.LoadQueue.loadTimeout = self.options.imagePreloadTimeout;
      self._preloadThumbsQueue = new createjs.LoadQueue(false);
      self._preloadLargeQueue = new createjs.LoadQueue(false);
    }
  },
  hideLargerImage: function () {
    this.ui.imageLarge.hide();
    this.ui.imageLarge.css(
      'background-image',
      'none'
    );
  },
  resizeImageHeight: function (height) {
    this.ui.imageLarge.css(
      'height',
      height + 'px'
    );
    this.ui.image.css(
      'height',
      height + 'px'
    );
  },
  loadLargerImage: function () {
    var self = this;
    var viewId = self.viewId();
    var imageURL = self.options.afterLoadImageURL;
    if (imageURL === null) {
      return;
    }

    function setImage(imageURL) {
      self.ui.imageLarge.css(
        'background-image',
        'url(' + imageURL + ')'
      );
      self.imageLoaded = true;
      self.ui.imageLarge.show();
      self.trigger('image:display:large:image:loaded', viewId);
    }

      var handleFileLoadError = function (event) {
        if (!self.isRendered) {
          return false;
        }
        if (event.item.id === viewId) {
          console.log('File load error occurred: ', event);
          self._preloadLargeQueue.removeAllEventListeners('fileload');
          self._preloadLargeQueue.removeAllEventListeners('error');
        }
      };

      var handleFileLoaded = function (event) {
        if (!self.isRendered) {
          return false;
        }
        if (event.item.id === viewId) {
          self._preloadLargeQueue.removeAllEventListeners('fileload');
          self._preloadLargeQueue.removeAllEventListeners('error');
          setImage(event.item.src);
        }
      };

      self._preloadLargeQueue.on('error', handleFileLoadError);
      self._preloadLargeQueue.on('fileload', handleFileLoaded);
      self._preloadLargeQueue.loadFile({
        id: viewId,
        src: imageURL
      });
  },
  _renderImage: function () {
    var self = this;
    var viewId = self.viewId();

    function setImage(imageURL) {
      self.ui.image.css(
        'background-image',
        'url(' + imageURL + ')'
      );
      self.imageLoaded = true;
    }

    var imageURL = self.options.imageURL;

    if(!self.options.displayNoImageAvailableIcon && !imageURL) {
      return;
    } else if (!imageURL) {
      imageURL = self.options.noImageAvailableIcon;
    }

    if (!self.options.displayImagePreloadingEffects) {
      setImage(imageURL);
      self.trigger('image:display:image:loaded', viewId);
    } else {
      self.loaderRegion.show(
        new(require('treeline-shared-components/spinner'))({
          message: ''
        })
      );
      var handleFileLoadError = function (event) {
        if (!self.isRendered) {
          return false;
        }
        if (event.item.id === viewId) {
          console.log('File load error occurred: ', event);
          self._preloadThumbsQueue.removeAllEventListeners('fileload');
          self._preloadThumbsQueue.removeAllEventListeners('error');
          self.loaderRegion.empty();
          setImage(self.options.noImageAvailableIcon);
          self.trigger('image:display:image:loaded', viewId);
        }
      };

      var handleFileLoaded = function (event) {
        if (!self.isRendered) {
          return false;
        }
        if (event.item.id === viewId) {
          self._preloadThumbsQueue.removeAllEventListeners('fileload');
          self._preloadThumbsQueue.removeAllEventListeners('error');
          self.loaderRegion.empty();
          setImage(event.item.src);
          self.trigger('image:display:image:loaded', viewId);
        }
      };

      self._preloadThumbsQueue.on('error', handleFileLoadError);
      self._preloadThumbsQueue.on('fileload', handleFileLoaded);
      self._preloadThumbsQueue.loadFile({
        id: viewId,
        src: imageURL
      });
    }
  },
  onRender: function () {
    this._renderImage();
  },
  onDestroy: function () {
    this._preloadThumbsQueue.removeAllEventListeners('fileload');
    this._preloadThumbsQueue.removeAllEventListeners('error');
    this._preloadThumbsQueue.reset();
    this._preloadThumbsQueue.removeAll();

    this._preloadLargeQueue.removeAllEventListeners('fileload');
    this._preloadLargeQueue.removeAllEventListeners('error');
    this._preloadLargeQueue.reset();
    this._preloadLargeQueue.removeAll();
  }
});
module.exports = View;



/** WEBPACK FOOTER **
 ** ./assets/js/common/product-tile/image-display.js
 **/